import { render, staticRenderFns } from "./Webinars.vue?vue&type=template&id=225431f8"
import script from "./Webinars.vue?vue&type=script&lang=js"
export * from "./Webinars.vue?vue&type=script&lang=js"
import style0 from "./Webinars.vue?vue&type=style&index=0&id=225431f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports